/**
 * map of content.contenType as key and the import path (from ~/components/solepro/) of the  component to render as value
 */
export const ALLOWED_COMPONENTS = {
  row: () => import('~/components/solepro/PageBuilder/Row.vue'),
  'column-group': () => import('~/components/solepro/PageBuilder/ColumnGroup.vue'),
  'column-line': () => import('~/components/solepro/PageBuilder/ColumnLine.vue'),
  'column': () => import('~/components/solepro/PageBuilder/Column.vue'),
  tabs: () => import('~/components/solepro/PageBuilder/Tabber.vue'),
  'tab-item': true, // mapping just to make an object to use inside Tabber
  'video': () => import('~/components/solepro/PageBuilder/Video.vue'),
  'banner': () => import('~/components/solepro/PageBuilder/Banner.vue'),
  'slider': () => import('~/components/solepro/PageBuilder/Slider.vue'),
  // 'slide': () => import('~/components/solepro/PageBuilder/Slide.vue'),
  'evidences': () => import('~/components/solepro/PageBuilder/Evidences.vue'),
  'tutorial': () => import('~/components/solepro/PageBuilder/Tutorial.vue'),
  // 'evidence': () => import('~/components/solepro/PageBuilder/Evidence.vue'),
  'products': () => import('~/components/solepro/PageBuilder/Products.vue'),
  'block': () => import('~/components/solepro/PageBuilder/Block.vue'),
  'image': () => import('~/components/solepro/PageBuilder/Image.vue'),
  'buttons': () => import('~/components/solepro/PageBuilder/Buttons.vue'),
  'accordion': () => import('~/components/solepro/PageBuilder/Accordion.vue'),
  'plp-product-box': () => import('~/components/solepro/PageBuilder/PLPProductBoxWrapper.vue'),
  'punti-forza-grid': () => import('~/components/solepro/PageBuilder/PuntiForzaGrid.vue'),
  'logos-carousel': () => import('~/components/solepro/PageBuilder/LogosCarousel.vue'),
  'pacchetti-marketing': () => import('~/components/solepro/PageBuilder/MarketingCards/MarketingCards.vue'),
  'marketing-1-prodotto': () => import('~/components/solepro/PageBuilder/MarketingProduct/MarketingProduct.vue'),
  'text-carousel': () => import('~/components/solepro/PageBuilder/TextCarousel.vue'),
  'plans-benchmark': () => import('~/components/solepro/PageBuilder/EditorialBenchmark.vue'),
  'home-eventi': () => import('~/components/solepro/PageBuilder/Events.vue'),
};



export const getComponent = (componentName, cssClasses = []) => {
  if (cssClasses.includes('section-tutorials')) {
    return ALLOWED_COMPONENTS['tutorial']
  } else if (cssClasses.includes('plp-product-box')) {
    return ALLOWED_COMPONENTS['plp-product-box']
  } else if (cssClasses.includes('punti-forza-grid')) {
    return ALLOWED_COMPONENTS['punti-forza-grid']
  } else if (cssClasses.includes('logos-carousel')) {
    return ALLOWED_COMPONENTS['logos-carousel']
  } else if (cssClasses.includes('pacchetti-marketing')) {
    return ALLOWED_COMPONENTS['pacchetti-marketing']
  } else if (cssClasses.includes('marketing-1-prodotto')) {
    return ALLOWED_COMPONENTS['marketing-1-prodotto']
  } else if (cssClasses.includes('text-carousel')) {
    return ALLOWED_COMPONENTS['text-carousel']
  } else if (cssClasses.includes('plans-benchmark')) {
    return ALLOWED_COMPONENTS['plans-benchmark']
  } else if (cssClasses.includes('home-eventi')) {
    return ALLOWED_COMPONENTS['home-eventi']
  }
  return (componentName && !!ALLOWED_COMPONENTS[componentName] && typeof ALLOWED_COMPONENTS[componentName] != 'boolean' ? ALLOWED_COMPONENTS[componentName] : 'div');
}



